import { useEffect, useState } from "react";
import './styles.js';
import { Container, Content, SelectContainer } from "./styles.js";
import MoviesMoov from "./moov/index.js";
import MoviesTmdb from "./tmdb/index.js";
import { RiListSettingsFill } from "react-icons/ri";

export default function Movies({ all_movies, movies_person, person_id, maximized, setShowFilters, filters, setFilters }) {
    
    const [movieType, setMovieType] = useState('all');
    const [platform, setPlatform] = useState('moov');

    useEffect(()=>{
        setMovieType("all");
        setShowFilters(false);
    }, [ platform ])

    const handleMoviesSettings = (e, setState) => {
        setState(e.target.value);
    };

    return (
        <Container>
            {
                <header>
                    <SelectContainer>
                        <label htmlFor="type-select">Tipo</label>
                        <select id="type-select" value={movieType} onChange={(e)=>handleMoviesSettings(e, setMovieType)}>
                            <option value="all">Tudo</option>
                            <option value="movie">Filmes</option>
                            <option value="tv">Séries</option>
                        </select>
                    </SelectContainer>
                    <SelectContainer>
                        <label htmlFor="avaliable-on">Plataforma</label>
                        <select id="avaliable-on" value={platform} onChange={(e)=>handleMoviesSettings(e, setPlatform)}>
                            <option value="moov">Moov</option>
                            <option value="others">Outras</option>
                        </select>
                    </SelectContainer>
                     {platform == "others" &&
                        <SelectContainer>
                            <label htmlFor="avaliable-on">Filtros</label>
                            <button onClick={()=>setShowFilters(true)}><i className="fas fa-plus"></i></button>
                        </SelectContainer>
                     }
                </header>
            }
            {Object.keys(filters).length > 0 && (
                <button onClick={()=>setShowFilters(true)} className="button-alert-filters-activated">* Filtros ativados</button>
            )}
            {platform == 'moov' && <MoviesMoov movies_person={movies_person} person_id={person_id} all_movies={all_movies} maximized={maximized} movieType={movieType}/>}
            {platform == 'others' && <MoviesTmdb person_id={person_id} movieType={movieType} filters={filters} setFilters={setFilters} />}
        </Container>
    );
}
